import { render, staticRenderFns } from "./PromptInstall.vue?vue&type=template&id=571fecfc&scoped=true&"
import script from "./PromptInstall.vue?vue&type=script&lang=js&"
export * from "./PromptInstall.vue?vue&type=script&lang=js&"
import style0 from "./PromptInstall.vue?vue&type=style&index=0&id=571fecfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fecfc",
  null
  
)

export default component.exports